/////// GALLERY Logic ///////

jQuery(function () {
    // --- STARTUP FIXES ---

    // Zoom feature for JQuery, runs only on larger screens
    if (jQuery(window).width() > 767){
      jQuery('.image-zoom')
      .wrap('<span style="display:inline-block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        url: jQuery(this).find('img').attr('data-zoom')
      });
    }
  
    // Photo Gallery
    jQuery('.slider-for').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });

    // Photo Gallery Navigation
    jQuery('.slider-nav').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        focusOnSelect: true,
        verticalSwiping: true,
        arrows: true,
        vertical: true,
        prevArrow: "<span class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0248/8539/5502/files/top-arrow.png'></span>",
        nextArrow: "<span class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0248/8539/5502/files/bottom-arrow.png'></span>",
        responsive: [{
                breakpoint: 992,
                settings: {
                    vertical: false,
                    arrows: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    vertical: false,
                    arrows: true,
                }
            },
            {
                breakpoint: 580,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    arrows: true,
                }
            },
            {
                breakpoint: 380,
                settings: {
                    vertical: false,
                    slidesToShow: 3,
                    arrows: true,
                }
            }
        ]
    });
});

jQuery(window).on("load", function(){
  setTimeout(function () {
      jQuery('.vehicle-detail-banner.banner-content.clearfix .slick-slide.slick-current.slick-active').click();
      jQuery('.slider-for .slick-track').attr('style', 'opacity: 1; width: 3736px; transform: translate3d(0px, 0px, 0px)');
      jQuery('.slider-for .slick-slide').attr('style', 'width: 467px; position: relative; top: 0px; z-index: 998; opacity: 1;');
      jQuery('.slider-for .slick-slide').find('div').attr('style', 'width: 467px;');
  }, 1000);
});

var minHeightSlideThumb = parseFloat(jQuery('.slider.slider-nav.thumb-image .slick-list').height()) / 4;
jQuery('.slider.slider-nav.thumb-image .slick-track .slick-slide').css('min-height', '100px');

jQuery(window).resize(function () {
    minHeightSlideThumb = parseFloat(jQuery('.slider.slider-nav.thumb-image .slick-list').height()) / 4;
    jQuery('.slider.slider-nav.thumb-image .slick-track .slick-slide').css('min-height', '100px');
});

setTimeout(function () {
    jQuery('body').show();
    jQuery('.product_handle_main').remove();
    jQuery('.slider.slider-nav.thumb-image .a-left.control-c.prev.slick-prev').click();
}, 1500);

////// CONFIGURATOR Logic //////

// check if field of options is a custom built option area like checkboxes for ssds, 
// if it is not, we add default name of label 
jQuery('.field').find('label').each(function () {
    if (!jQuery(this).hasClass('admin__field-label')) {
        jQuery(this).addClass('label_only_custom');
    }
});

// Generic limiter for any quantity input associated with a dropdown option.
// This targets any number input inside a container with an ID starting "dynamic_option_id_".
jQuery(document).on('input', '[id^="dynamic_option_id_"] input[type="number"]', function() {
    const qtyInput = jQuery(this);
    
    // The container is the closest element matching the pattern.
    const container = qtyInput.closest('[id^="dynamic_option_id_"]');
    
    if (container.length) {
        // --- Determine the effective maxItems ---
        let effectiveMaxItems = parseInt(container.attr("max-item") || '0'); // Default from container

        // Try to find an associated select and its selected option for a more specific limit.
        // This assumes the qtyInput is in the same '.field' as the select, or a sibling.
        const associatedSelect = qtyInput.closest('.field').find('select.product-custom-option');
        
        if (associatedSelect.length) {
            const selectedOption = associatedSelect.find('option:selected');
            if (selectedOption.length && selectedOption.attr('data-max-item')) {
                const optionMaxItems = parseInt(selectedOption.attr('data-max-item'));
                // Only override if the option's max-item is a valid positive number
                if (!isNaN(optionMaxItems) && optionMaxItems > 0) {
                    effectiveMaxItems = optionMaxItems;
                }
            }
        }

        const currentValue = parseInt(qtyInput.val() || '0');

        // Apply the determined limit
        if (effectiveMaxItems > 0 && currentValue > effectiveMaxItems) {
            qtyInput.val(effectiveMaxItems);
        }

        // --- Trigger the summary update ---
        // Find the associated product option dropdown within the same container and trigger 'change'.
        container.find('select.product-custom-option').trigger('change');
    }
});

// Render Summary for SSDs 
// This needs to be well set up so it can work with different types of SSDs
let html_counter = []; // or Array()
jQuery('tr.fields').find('.field').each(function () {
    let field_label = jQuery(this).find('label.label_only_custom').text(); // fetch the text value of the field

    if(field_label.includes("SATA Storage"))
        field_label = "SATA Storage";
    else if(field_label.includes("NVMe M.2 Storage"))
        field_label = "NVMe M.2 Storage";
    else if(field_label.includes("NVMe U.2 Storage"))
        field_label = "NVMe U.2 Storage";
    else if(field_label.includes("Complimentary Software"))
        field_label = "Complimentary Software"

    html_counter.push('<div class="single-item-inner" data-row-field="' + field_label + '"> <div class="img_container"> <span class="unchecked"><img src="https://cdn.shopify.com/s/files/1/0248/8539/5502/files/unchecked.png"></span> <span class="checked" style="display: none;"><img src="https://cdn.shopify.com/s/files/1/0248/8539/5502/files/checked.png"></span> </div> <div class="content_container_options"><div class="content_headers_functions"> <div class="field__title">' + field_label + '</div> <div class="field__Qty">Qty</div> <div class="field__Price">Price</div></div><div class="content_options_explorations"></div> </div> </div>');

});

jQuery('.cloudninjas_final_variants').html('<div class="single-item-row">' + html_counter + '</div>');

// Configurator Summary Render of items, QTY and price
jQuery(document).on('change', '.product-custom-option', function(evt) {

    // Logic for when we change an option from the previous one, the summary will be reset for the SSD options 
    // and ready to be populated with the new chosen options
    jQuery("[data-row-field='SATA Storage'] .content_container_options .content_options_explorations").empty();
    jQuery("[data-row-field='NVMe M.2 Storage'] .content_container_options .content_options_explorations").empty();
    jQuery("[data-row-field='NVMe U.2 Storage'] .content_container_options .content_options_explorations").empty();
    jQuery("[data-row-field='Complimentary Software'] .content_container_options .content_options_explorations").empty();

    // retrieves the multiple attributes of the element that triggered the change event.
    // determine if the selected option allows multiple values (checkbox for SSDs)
    // let getIfMultipleAttr = jQuery(this).attr('multiple'); // add the multiple attribute to html tag

    // if multiple options selected 
    let optionTextAll = []; // array that holds all options selected

    //  On custom.js.liquid we have an if statement checking if 'multiple' attribute exists in the class of the element, right now nothing has been found to find the usage of such statement 

    // grabs every option's text that is selected, and adds to summary limiting the number of characters to 32 (truncate) and swapping the rest with '...'
    jQuery(this).find('option').each(function (){
        // each option contains a selected property
        if(jQuery(this).prop('selected') == true ){
            let optionText = jQuery(this).text(); // variable contains text value of each option element

            // substring of option up to the pricing within the HTML elements value
            // so price is not added in the summary under the option name
            let optionStringVal;
            let optionStringVal_truncated; 
            if(optionText.indexOf('+') > -1){
                optionStringVal = jQuery.trim(optionText.split('+')[0]); // stores option string value without price and other characters
                optionStringVal_truncated = jQuery.trim(optionStringVal).substr(0,24) + '...'; // trucate string up to 32 characters
                console.log(optionStringVal_truncated);
            }else { // if option in select tag does not contain pricing
                // if option string is longer than 24 and does not contain price and ('+') character 
                if(optionText.length > 24 ){
                    optionStringVal_truncated = jQuery.trim(optionText).substr(0,32) + '...'; 
                }else {
                    optionStringVal_truncated = jQuery.trim(optionText).substr(0,32); 
                }
            }

            // fetching the input value of the option
            let optionQtyVal;
            if(jQuery(this).closest('.field').find('input[type="number"]').val()){
                optionQtyVal = jQuery(this).closest('.field').find('input[type="number"]').val();
            }else {
                optionQtyVal = '1';
            }

            //fetching price from option
            const unitPrice = parseFloat(jQuery(this).attr('price') || '0');
            const itemQty = parseInt(optionQtyVal || '1');
            const qtyWithPrice = itemQty * unitPrice;


            optionTextAll.push('<div class="inside_items_full_width" data-decision-toggle="' + jQuery.trim(optionStringVal_truncated) + '"><div class="field__title">' + optionStringVal_truncated + '</div><div class="field__Qty" data-qty="' + optionQtyVal + '">' + optionQtyVal + '</div><div class="field__Price" data-item-price="' + qtyWithPrice + '">$' + qtyWithPrice + '</div></div>')
        }
    });

    // store string value of label for each option box (Processor (CPU), Memory - Select Up to 24 Modules, etc...) 
    let field_label = jQuery.trim(jQuery(this).closest('.field').find('label').text());
    // for each option item, match its label string value to the summary element that contains the same option label with value stored in 'data-row-field' attribute
    // if it matches add, all array elements of every option that is selected for each choice box 
    jQuery('.single-item-inner').each(function() {
        let dataRowField = jQuery.trim(jQuery(this).attr('data-row-field'));
        if(dataRowField == field_label) {
            jQuery(this).find('.content_options_explorations').html(optionTextAll);
        }
    });


    // Call master function for dynamic configurator for SSDs checkbox
    updateAllSummaries();

});


// --- DYNAMIC CONFIGURATOR MAP SETUP --- //
/*

1. Function to initialize Configuration map
*Based on the chassis type, we will attach each option property type for ssds to allow dropdown 
and summary section to correctly display the drives. Instead of hardcode  
* Determines and sets the appropriate configurationMap on Page context
* title will be based on software's so Map structure will be extremenly big but for now only option
* map structure is based on chassis name, since chassis will have the same names no matter what type of software page it is

2. Function to loop through the configurator map
* Loops through the configurator map and updates all relevant summary sections.
*/
let activeConfigMap = {};

function initializeDynamicConfiguratorMap() {
    const productTitle = jQuery('.field__titlea1').text(); // gets variant name (CHASSIS NAME)
    
    // statement to check chassis and assing map configuration for drives
    if(productTitle.includes('Cloud Ninjas Iron Bull')){

        // --- Active Map for this Configurator -- //
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }

    }
    else if(productTitle.includes('Cloud Ninjas Mythical Dragon')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe U.2 Storage',
            '#options-1005-list': 'NVMe M.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }

    }
    else if(productTitle.includes('Cloud Ninjas Shadow Leopard')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }

    }
    else if(productTitle.includes('Cloud Ninjas Phatom Lynx Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }

    }
    else if(productTitle.includes('Cloud Ninjas Phantom Lynx Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }

    }
    else if (productTitle.includes('Cloud Ninjas Primal Gorilla')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe U.2 Storage',
            '#options-1005-list': 'NVMe M.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }
    }
    else if (productTitle.includes('Cloud Ninjas Rhino Juggernaut')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage',
            '#options-1005-list': 'NVMe U.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }
    }
    else if (productTitle.includes('Cloud Ninjas Fierce Tiger')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage',
            '#options-1005-list': 'NVMe U.2 Storage',
            '#options-1011-list': 'Complimentary Software',
        }
    }
    else if (productTitle.includes('Cloud Ninjas Steel Wolf Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software',
        }
    }
    else if (productTitle.includes('Cloud Ninjas Steel Wolf Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software',
        }
    }
    else if (productTitle.includes('Cloud Ninjas Loyal Hound Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    
    }
    else if (productTitle.includes('Cloud Ninjas Loyal Hound Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Neon Fox Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Neon Fox Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Silent Owl Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Silent Owl Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Ghost Viper Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Ghost Viper Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Artic Falcon Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Artic Falcon Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Bold Eagle Air Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    else if (productTitle.includes('Cloud Ninjas Bold Eagle Liquid Cooled')){
        activeConfigMap = {
            '#options-1003-list': 'SATA Storage',
            '#options-1004-list': 'NVMe M.2 Storage', 
            '#options-1011-list': 'Complimentary Software'
        }
    }
    
    // You can add 'else if' blocks here for other specific configurators
}

// call configuration map on page loading 
jQuery(document).ready(function () {
    initializeDynamicConfiguratorMap();
});

// Function #2
function updateAllSummaries() {
    
    for (const listSelector in activeConfigMap){
        // iterates through every defined map configuration on first function
        const summaryFieldName = activeConfigMap[listSelector];

        const optionList = jQuery(listSelector);
        const summaryRow = jQuery(`[data-row-field='${summaryFieldName}']`);

        // only if both options have the same string value (same name, which is the chassis name or variant name within shopify)
        if(optionList.length > 0 && summaryRow.length > 0){
            const summaryContainer = summaryRow.find('.content_options_explorations');
            summaryContainer.empty(); // clear specific container
            
            optionList.find('.field.choice.admin__field.admin__field-option input:checked').each(function (){
                const checkbox = jQuery(this);
                const itemLabel = checkbox.next().find("span").text();
                const itemQty = parseInt(checkbox.next().next().find("input").val() || '1');
                const itemPrice = parseFloat(checkbox.attr("price") || '0');

                const truncated_title = itemLabel.length > 32 ? itemLabel.substr(0, 32) + '...' : itemLabel;

                summaryContainer.append(jQuery(`<div class="inside_items_full_width" data-decision-toggle="${itemLabel}">
                    <div class="field__title">${truncated_title}</div>
                    <div class="field__Qty" data-qty="${itemQty}">${itemQty}</div>
                    <div class="field__Price" data-item-price="${itemPrice}">$${(itemPrice * itemQty).
                    toFixed(2)}</div>
                    </div>`
                ));
            });
        }
    }
}



// Updates chassis information on summary section 
// Updates Chassis Summary 
jQuery(document).on('change', '.product-form__variants', function (evt) {
    jQuery('chassi_option .content_options_explorationsa1 .field__titlea1').text( jQuery(this).find("option:selected").attr('data-var-idt') );
    jQuery('chassi_option .content_options_explorationsa1 .field__Pricea1').text( jQuery(this).find("option:selected").attr('data-custom-price') );

    // Gallery change on chassis change
    let productFormVariants = jQuery(this).find('option:selected').attr('data-var-idt');
    jQuery('.banner-slider').each(function () {
        let dataChassisType = jQuery(this).attr('data-chassis-type');
        if (productFormVariants == dataChassisType) {
            jQuery(this).addClass('active').show();
            jQuery('.vehicle-detail-banner.banner-content.clearfix .slick-slide.slick-current.slick-active').click();
            jQuery('.slider-for .slick-track').attr('style', 'opacity: 1; width: 3736px; transform: translate3d(0px, 0px, 0px)');
            jQuery('.slider-for .slick-slide').attr('style', 'width: 467px; position: relative; top: 0px; z-index: 998; opacity: 1;');
            jQuery('.slider-for .slick-slide').find('div').attr('style', 'width: 467px;');
        } else {
            jQuery(this).removeClass('active').hide();
        }
    });
});

/* ------ RENDERING SSD Options in Checkbox Style ----- */

/* ------ REFACTORED DRIVE OPTION LOGIC ----- */

// --- 1. CONFIGURATION MAP for Drive Lists ---
// This map connects each drive list to the container that holds its "max-item" limit attribute.
const driveConfigMap = {
    '#options-1003-list': { limitContainer: '#dynamic_option_id_1003' },
    '#options-1004-list': { limitContainer: '#dynamic_option_id_1004' },
    '#options-1005-list': { limitContainer: '#dynamic_option_id_1005' },
};

// --- 2. GENERIC HELPER FUNCTIONS (replaces all old get...Limit and getTotal... functions) ---

/**
 * Gets the storage option limit for a given option list's container.
 * @param {string} limitContainerSelector - The selector for the element holding the 'max-item' attribute.
 * @returns {number} The maximum number of items allowed.
*/

function getDriveLimit(limitContainerSelector) {
  // Use '0' as a fallback to prevent NaN errors
  return parseInt(jQuery(limitContainerSelector).attr("max-item") || '0');
}

/**
 * Gets the total number of selected drives in a specific option list.
 * @param {string} listSelector - The jQuery selector for the option list to count drives in.
 * @returns {number} The total quantity of selected drives.
*/

function getTotalSelectedDrivesInList(listSelector) {
  let totalDrives = 0;
  jQuery(listSelector).find("input[type='number']").each(function() {
    // Use '0' as a fallback to prevent NaN errors
    totalDrives += parseInt(jQuery(this).val() || '0');
  });
  return totalDrives;
}


// --- 3. SINGLE, GENERIC EVENT HANDLERS (replaces all old repetitive handlers) ---

// This one handler replaces the multiple 'keyup, change' handlers for quantity boxes.
jQuery(document).on('keyup change', '.option-qty', function(event) {
    const qtyInput = jQuery(this); // The specific quantity input that was changed.
    
    let matchedListSelector = null;
    
    // Figure out which of our configured drive lists this quantity input belongs to.
    for (const selector in driveConfigMap) {
        if (qtyInput.closest(selector).length > 0) {
            matchedListSelector = selector;
            break;
        }
    }
    
    if (!matchedListSelector) {
        return; // If the input isn't in a list we've configured, do nothing.
    }

    const config = driveConfigMap[matchedListSelector];
    const limit = getDriveLimit(config.limitContainer);
    const totalSelected = getTotalSelectedDrivesInList(matchedListSelector);
    
    // If the new total goes over the limit, undo the last increment.
    if (limit > 0 && totalSelected > limit) {
      const currentValue = parseInt(qtyInput.val() || '1');
      if (currentValue > 0) {
        qtyInput.val(currentValue - 1);
      }
    }
    
    const newTotalSelected = getTotalSelectedDrivesInList(matchedListSelector);
    const driveList = jQuery(matchedListSelector);

    // When the storage limit is reached, disable unselected options within THAT specific list.
    if (limit > 0 && newTotalSelected >= limit) {
        driveList.find(".field.choice.admin__field.admin__field-option").each(function() {
            const field = jQuery(this);
            if (!field.find("input[type='checkbox']").is(':checked') && field.find('input[type="number"]').length === 0) {
                field.addClass('inactive_temporary');
            }
        });
    } else {
        // Otherwise, make sure all options are enabled.
        driveList.find('.field.choice.admin__field.admin__field-option').removeClass('inactive_temporary');
    }

    // After handling limits, re-render the summary to update prices.
    updateAllSummaries();
});


// This one handler replaces the multiple 'click' handlers for the checkboxes.
jQuery(document).on('click', '.admin__control-checkbox', function () {
    const checkbox = jQuery(this);

    let matchedListSelector = null;

    // Figure out which of our configured drive lists this checkbox belongs to.
    for (const selector in driveConfigMap) {
        if (checkbox.closest(selector).length > 0) {
            matchedListSelector = selector;
            break;
        }
    }

    if (!matchedListSelector) {
        return; // If the checkbox isn't in a list we've configured, do nothing.
    }

    const config = driveConfigMap[matchedListSelector];
    const limit = getDriveLimit(config.limitContainer);
    const driveList = jQuery(matchedListSelector);

    // Use a short timeout to allow the DOM to update with the checkbox's new checked state.
    setTimeout(function() {
        const totalSelected = getTotalSelectedDrivesInList(matchedListSelector);
        
        if (limit > 0 && totalSelected >= limit) {
            driveList.find(".field.choice.admin__field.admin__field-option").each(function() {
                const field = jQuery(this);
                if (!field.find("input[type='checkbox']").is(':checked') && field.find('input[type="number"]').length === 0) {
                    field.addClass('inactive_temporary');
                }
            });
        } else {
            driveList.find('.field.choice.admin__field.admin__field-option').removeClass('inactive_temporary');
        }
    }, 10); // A 10ms delay is usually sufficient.
});

// shows every summary item related to the configurator
jQuery('.single-item-inner').addClass('active');
jQuery('.content_container_options').addClass('active');

/* ------ REFACTORED DROPDOWN ANIMATION LOGIC ----- */

// This single, generic handler replaces the four repetitive 'click' handlers
// for the '.close_storage' buttons.
jQuery(document).on('click', '.close_storage', function () {
    const closeButton = jQuery(this);
    
    // Find the closest parent container. This selector now only matches elements whose ID starts
    // with 'dynamic_option_id_'.
    const container = closeButton.closest('[id^="dynamic_option_id_"]');
    
    // Only proceed if a matching container was found.
    if (container.length > 0) {
        // Find active elements within THIS container and remove the 'active' class.
        container.find('.control.active select').removeClass('active');
        container.find('.control.active').removeClass('active');
        
        // Find the corresponding <select> element and animate its scroll to the top.
        // This logic derives the select ID from the container ID.
        const containerId = container.attr('id');
        if (containerId) { // containerId should always be present here as we selected by ID
            const id = containerId.split('_').pop();
            jQuery('#select_' + id).animate({ scrollTop: 0 }, 0);
        }
    }
});

/* ------ REFACTORED CUSTOM DROPDOWN LOGIC ----- */

// 1. Configuration map to link dropdown triggers to the elements they control.
const customDropdownMap = {
    '#select__storage__full':   { list: '#options-1003-list', container: '#dynamic_option_id_1003' },
    '#select__storage__full_2': { list: '#options-1004-list', container: '#dynamic_option_id_1004' }, 
    '#select__storage__full_3': { list: '#options-1005-list', container: '#dynamic_option_id_1005' }, 
    '#select_software_1' : { list: '#options-1011-list', container: '#dynamic_option_id_1011' }
};

// 2. Create a single selector string from the map keys for the event handler.
const dropdownTriggerSelectors = Object.keys(customDropdownMap).join(', ');

// 3. Single, generic event handler to replace all the repetitive ones.
jQuery(document).on('click', dropdownTriggerSelectors, function() {
    const clickedTrigger = jQuery(this);
    
    // Find the ID of the clicked trigger to look it up in the map.
    const triggerId = '#' + clickedTrigger.attr('id');
    const config = customDropdownMap[triggerId];

    // If a valid configuration is found, perform the toggle actions.
    if (config) {
        jQuery(config.list).slideToggle();
        jQuery(config.container).toggleClass('active_box');
        jQuery(config.list).toggleClass('active_box');
    }
});

/* ------ REFACTORED CHECKBOX STYLE REMOVAL ----- */

// 1. A single selector string that includes all elements that should trigger the style removal.
const checkboxStyleTriggers = [
    '#dynamic_option_id_1003',
    '#dynamic_option_id_1004',
    '#dynamic_option_id_1005', 
    '#dynamic_option_id_1011'
].join(', ');

// 2. This single handler replaces the four repetitive handlers from the old file.
// When any of the trigger containers are clicked, it removes the specified class.
jQuery(document).on('click', checkboxStyleTriggers, function() {
    jQuery('.field.choice.admin__field.admin__field-option').removeClass('dpo_swatch_text');
});

// This line runs once on page load to ensure the styles are removed initially.
jQuery('.field.choice.admin__field.admin__field-option').removeClass('dpo_swatch_text');


/* ------ REMAINING UNIQUE LOGIC FROM OLD FILE ----- */

// Prevents user from holding down the increment button on drive quantity selectors
jQuery(document).on('keyup, change, mousedown', '.option-qty', function (event) {
    jQuery('input[type="number"]').on('input', function () {
        const {
            lockedValue
        } = this.dataset

        if (lockedValue === undefined) {
            this.dataset.lockedValue = this.value
        } else {
            this.value = lockedValue
        }
    }).on('blur mouseup keyup touchend', function () {
        delete this.dataset.lockedValue
    })
});

//CHECK IF NEEDED DO NOT KNOW WHAT THIS DOES YET
setTimeout(function() {
  jQuery("[data-slick-index|='1']").trigger('click');
}, 100);

// Prevents keypress default action for quantity inputs
jQuery('.option-qty').keypress(function(e){
    if(e.which === 13){
        return false;
    }
});
